module.exports = __webpack_public_path__ + "img/1534065766.6a12b9d0.jpg";